import request from '@/utils/request'

export function getClubList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOrganizationList.json',
    method: 'post',
    data
  })
}

export function getClubEdit(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOrganization.json',
    method: 'post',
    data
  })
}

export function updateClubEdit(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateOrganization.json',
    method: 'post',
    data
  })
}

export function getOrganizationPlayerList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOrganizationPlayerList.json',
    method: 'post',
    data
  })
}

export function updateOrganizationPlayerStatus(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateOrganizationPlayerStatus.json',
    method: 'post',
    data
  })
}
